var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("special-requests-grid", {
    attrs: {
      value: _vm.value,
      "is-edit": !_vm.disabled,
      "customer-id": _vm.innerCustomerId,
      lob: _vm.job.lob,
      job: _vm.job
    },
    on: { input: _vm.onInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }